import './split-feature.scss';

import React from 'react';
import { Link } from 'react-router-dom';

import { formatEntryDate } from '../../../content';

export type SplitFeaturePlacement = 'Right' | 'Left';

export type SplitFeatureProps = {
  title: string;
  image: string;
  tags: string[];
  date: string;
  description: string;
  detailPath: string;
  placement: SplitFeaturePlacement;
};

export const SplitFeature: React.FC<SplitFeatureProps> = ({
  title,
  image,
  tags,
  date,
  description,
  detailPath,
  placement,
}) => {
  return (
    <div className="row pb-5 mb-md-4 mb-lg-5">
      <div
        className={
          placement === 'Right'
            ? 'rellax col-md-6 pb-1 mb-3 pb-md-0 mb-md-0'
            : 'rellax col-md-6 order-md-2 pb-1 mb-3 pb-md-0 mb-md-0'
        }
      >
        <img
          src={image}
          className="rounded-3 split-feature-image"
          alt={title}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div
        className="rellax col-md-6"
        data-rellax-percentage="0.5"
        data-rellax-speed="-0.6"
        data-disable-parallax-down="md"
      >
        <div className="ps-md-4 ms-md-2">
          <div className="fs-sm text-muted mb-1 entry-date">{formatEntryDate(date)}</div>
          <h2 className="h3 split-feature-title">{title}</h2>
          <div className="mb-3">
            {tags.map((tag) => (
              <span key={tag} className="d-inline-block badge fs-sm text-nav bg-secondary text-decoration-none me-2 entry-tag">
                {tag}
              </span>
            ))}
          </div>
          <p className="d-md-none d-lg-block pb-3 mb-2 mb-md-3 split-feature-description">{description}</p>
          <Link to={detailPath} className="btn btn-outline-primary split-feature-cta">
            View more
          </Link>
        </div>
      </div>
    </div>
  );
};
